import React, {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {SortDirection as SortDirections} from 'src/openapi/admin/models/SortDirection';

import {SortHeaderWithDataTable} from '@pb/kit-component-sort-header';


import {bulkActivityLogsStateActions, bulkActivityLogsStateSelector} from './slices/user-activity-log-state.slice';
import {ActivityLogSortFields} from './typedef';

import type {SortDirection} from 'src/openapi/admin/models/SortDirection';

type Props = {
    caption: string,
    sortField: ActivityLogSortFields,
};

export const SortableHeader = ({caption, sortField}: Props) => {
    const dispatch = useDispatch();
    const cacheKeys = useSelector(bulkActivityLogsStateSelector);

    const sort = useCallback((direction: ('ASC' | 'DESC')) => {
        dispatch(
            bulkActivityLogsStateActions.setSortCriteria({
                direction: direction as SortDirection,
                field: sortField,
            }),
        );
    }, [sortField, dispatch]);

    return (
        <SortHeaderWithDataTable
            defaultDirection={SortDirections.ASC}
            direction={cacheKeys.sortCriteria.field === sortField ? cacheKeys.sortCriteria.direction : null}
            filterActive={true}
            caption={caption}
            onSort={sort}
        />
    );
};
